import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {AsyncPipe, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ApiService} from '../../../services/api.service';
import {UserService} from '../../../services/user.service';
import {Router} from '@angular/router';
import {PopupService} from '../../../services/popup.service';
import {Store} from '@ngrx/store';
import {ReportService} from "../../../services/report.service";
import {shareReport} from "../../../state/report/report.actions";
import {selectShareReportFailure, selectShareReportSuccess} from "../../../state/report/report.selectors";
import {filter, Observable, Subscription, take} from "rxjs";
import {ReportState} from "../../../state/report/report.reducer";

@Component({
  selector: 'app-share',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    AsyncPipe
  ],
  templateUrl: './share.component.html',
  styleUrl: './share.component.scss'
})
export class ShareComponent {

  @Input() isVisible: boolean = false;
  @Output() modalClosed: EventEmitter<void> = new EventEmitter();

  form: FormGroup;

  reportSubscription: Subscription;
  report: any;

  loading$: Observable<boolean>;

  constructor(
    public formBuilder: FormBuilder,
    private reportService: ReportService,
    private popupService: PopupService,
    private store: Store<{ report: ReportState }>
  ) {

    this.reportSubscription = reportService.report$.subscribe(
      report => { this.report = report; }
    );

    this.form = formBuilder.group(
      {
        email: ['', [Validators.required, Validators.email]],
        message: ['']
      },
      { updateOn: "blur" }
    );

    this.loading$ = this.store.select(state => state.report.loading);

  }

  closeModal() {
    this.isVisible = false;
    this.modalClosed.emit(); // Notify the parent component that the modal has been closed

    // Reset form
    this.form.reset();
  }

  shareReport() {
    if(this.form.valid) {
      const email = this.form.value.email;
      const message = this.form.value.message;
      const search_id = this.report.id;

      // Create a single subscription to monitor the HTTP request directly
      const httpSubscription = this.reportService.shareReport(email, search_id, message)
        .subscribe({
          next: (response) => {
            console.log('Share report successful response:', response);
            this.closeModal();
            this.popupService.notify('Report has been successfully shared!', 'Share success', 'success');
          },
          error: (error) => {
            console.error('Share report error:', error);
            const errorMessage = error?.error?.message || 'Failed to share the report.';
            this.popupService.notify(errorMessage, 'Share report error', 'error');
          },
          complete: () => {
            // Clean up when done
            if (httpSubscription) {
              httpSubscription.unsubscribe();
            }
          }
        });
    }
  }

}
